var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.urlDomain,"target":"_blank"}},[_vm._v(_vm._s(_vm.params.data.sourceDomain)),_c('i',{staticClass:"fas fa-arrow-up-right-from-square"})])])}
var staticRenderFns = []

export { render, staticRenderFns }